<script setup lang="ts">
  import {
    breadCrumbItemContainerClass,
    breadCrumbItemLastTitleClass,
    breadCrumbItemTitleClass,
    itemDividerClass,
  } from './BreadCrumbItem.css';
  import { computed } from 'vue';
  import { Link, LinkVariant } from '@tundr/ds-components';
  import type { BreadCrumbItemProps } from './BreadCrumbItem.types';

  const props = defineProps<BreadCrumbItemProps & { isLast: boolean }>();

  const isNavigable = computed(
    () => !props.isLast && (!!props.to || !!props.onClick),
  );

  const titleClasses = computed(() => [
    breadCrumbItemTitleClass,
    { [breadCrumbItemLastTitleClass]: props.isLast },
  ]);
</script>

<template>
  <div :class="breadCrumbItemContainerClass">
    <Link
      v-if="isNavigable"
      :to="to"
      :variant="LinkVariant.Secondary"
      @click="onClick?.()"
    >
      {{ title }}
    </Link>
    <span
      v-else
      :class="titleClasses"
      :aria-current="isLast ? 'page' : undefined"
      >{{
        title
      }}</span
    >
    <span :class="itemDividerClass" v-if="!isLast">/</span>
  </div>
</template>
